(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeemedClearanceApprovalDialogController', DeemedClearanceApprovalDialogController);

    DeemedClearanceApprovalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DeemedClearanceApproval'];

    function DeemedClearanceApprovalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DeemedClearanceApproval) {
        var vm = this;

        vm.deemedClearanceApproval = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.deemedClearanceApproval.id !== null) {
                DeemedClearanceApproval.update(vm.deemedClearanceApproval, onSaveSuccess, onSaveError);
            } else {
                DeemedClearanceApproval.save(vm.deemedClearanceApproval, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:deemedClearanceApprovalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
